import type { InstancedMesh } from '@babylonjs/core/Meshes/instancedMesh';
import type { Mesh } from '@babylonjs/core/Meshes/mesh';
import type { TransformNode } from '@babylonjs/core/Meshes/transformNode';
import type { ITransformRT3 } from '@seddi/math-v2';
import { createQuaternion, createVector3 } from '../maths/math.vector';

/**
 * Create mesh instance.
 * @param id - The instance id.
 * @param mesh - The mesh model to create instances from.
 * @param transform - The instance transform.
 * @param bnode - The parent node.
 */
function create(
  id: string,
  mesh: Mesh,
  transform: ITransformRT3,
  bnode: TransformNode,
): InstancedMesh {
  const { rotation, translation } = transform;
  const instance = mesh.createInstance(id);
  instance.parent = bnode;
  instance.position = createVector3(translation);
  instance.rotationQuaternion = createQuaternion(rotation);
  return instance;
}

export const InstancedMeshExt = {
  create,
};
